module.exports = __webpack_public_path__ + "img/weight-painting.21dbe430.png";